import { Component, OnInit } from '@angular/core';
import { AuthProvider }       from '@providers/auth/auth';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import * as moment from 'moment';
import * as momentDurationFormatSetup from "moment-duration-format";
import { App } from 'ionic-angular';
import { NuevaCampaniaPage, FinCampaniaPage } from '@pages';

momentDurationFormatSetup(moment)

@Component({
  selector: 'campaign-active',
  templateUrl: 'campaign-active.html'
})
export class CampaignActiveComponent implements OnInit {

  campaign: any = null;
  formatCounterBack: string;
  equipo: any;
  jugador: any;
  interval: any;
  indice: number = 0;

  constructor(
    private authProvider: AuthProvider,
    private campaignsProvider: CampaignsProvider,
    public app: App) {
  }

  ngOnInit() {
    // this.init();
  }

  async init(): Promise<any> {
    try {
      this.jugador  = await this.authProvider.getSession()
      this.equipo   = await this.authProvider.getEquipo();
      this.campaign = await this.campaignsProvider.getCampaignActive(this.equipo.area._id);
      await this.campaignsProvider.save(this.campaign)

      if(this.interval) {
        clearInterval(this.interval);
      }

      if(this.campaign) {
        let isShowing = await this.campaignsProvider.isShowing();
        if(!isShowing) {
          this.app.getRootNavs()[0].setRoot(NuevaCampaniaPage, {
            campania: this.campaign
          });
        } else {
          this.interval = setInterval(() => this.format(), 1000);
        }
      } else {
        let existedCampaign = await this.campaignsProvider.existedCampaign();
        let isShowingFinCampania = await this.campaignsProvider.isShowingFinCampania();
        if(existedCampaign && !isShowingFinCampania) {
          let estadisticas =  await this.campaignsProvider.getUltimaCampaniaFinalizada(this.equipo.area._id, this.jugador._id);
          this.app.getRootNavs()[0].setRoot(FinCampaniaPage, {
            estadisticas: estadisticas
          });
        }
      }
    } catch(e) {
       console.log('Error::CampaignActiveComponent::ngOnInit', e)
    }
  }

  format() {
    let now      = moment();
    let fechaFin = moment(this.campaign.fechaFin);

    let ms = moment(fechaFin,"DD/MM/YYYY HH:mm:ss").diff(moment(now,"DD/MM/YYYY HH:mm:ss"));
    let d = moment.duration(ms);

    let diasRestantes = Math.floor(d.asDays());
    let horasRestantes = Math.floor(d.asHours());

    if(horasRestantes > 24) {
      horasRestantes = horasRestantes % 24;
    }

    if(diasRestantes > 1) {
      // @ts-ignore
      this.formatCounterBack = `${diasRestantes} días ${horasRestantes}:${moment.utc(d.asMilliseconds()).format("mm:ss")}`
    } else if(diasRestantes == 1){
      // @ts-ignore
      this.formatCounterBack = `${diasRestantes} día ${horasRestantes}:${moment.utc(d.asMilliseconds()).format("mm:ss")}`
    } else {
      // @ts-ignore
      this.formatCounterBack = d.format("HH:mm:ss")
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/campaign-active/campaign-active.ts